var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.thread["context-info"]
    ? _c(
        "div",
        {
          staticClass: "blubber_sideinfo responsive-hidden",
        },
        [
          _c("div", {
            staticClass: "context_info",
            domProps: {
              innerHTML: _vm._s(_vm.thread["context-info"]),
            },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }